export function providerSectionCopy(tasks = []) {
  const confirmed = tasks.every(
    (task) => task.status === "completed" && task.proof_level !== "none",
  );
  return confirmed
    ? {
        title: "Confirmed actions",
        caption: "Reported by the connected app, not the agent.",
      }
    : {
        title: "Connected-service steps",
        caption: "These steps require confirmation from the connected app.",
      };
}
